import axios from "axios";

export const baseURL = "https://trukkers-konnect-2e73c4741c00.herokuapp.com";
// export const baseURL = "http://192.168.18.254:8000";

// ---------------- Axios Instance ----------------
const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

// ---------------- Request Interceptor ----------------
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("[REQUEST ERROR]", error);
    return Promise.reject(error);
  },
);

// ---------------- Response Interceptor ----------------
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // Handle expired access token
    if ((status === 401 || status === 498) && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refresh_token");

        if (!refreshToken) {
          localStorage.clear();
          window.location.reload();
          return Promise.reject(error);
        }

        const res = await axios.post(`${baseURL}/auth/renew-token`, {
          refresh_token: refreshToken,
        });

        const { access_token } = res.data.tokens;

        localStorage.setItem("auth_token", access_token);

        originalRequest.headers.Authorization = `Bearer ${access_token}`;

        return api(originalRequest);
      } catch (refreshError) {
        localStorage.clear();
        window.location.reload();
      }
    }

    return Promise.reject(error);
  },
);

// ---------------- Generic API Caller ----------------
const apiHandle = async (
  endpoint,
  method,
  data = null,
  extraHeaders = {},
  params = null,
) => {
  try {
    let body = data;
    const headers = { ...extraHeaders };

    if (data && !(data instanceof FormData)) {
      body = JSON.stringify(data);
      headers["Content-Type"] = "application/json";
    }

    const config = {
      url: endpoint,
      method,
      headers,
    };

    // Add query parameters if provided
    if (params) {
      config.params = params;
    }

    if (body !== null && body !== undefined) {
      config.data = body;
    }

    const res = await api(config);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: "Something went wrong" };
  }
};

export default apiHandle;
